import Inventory from "../../pages/Inventory";
import { InternalUserRoles } from "../../constants/roles";
import { ReactComponent as InventoryIcon } from "../../assets/inventoryicon.svg";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/inventory";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Inventory,
  allowedRoles: InternalUserRoles,
  label: "Inventory",
  icon: () => <InventoryIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const inventoryRoutes: { [key: string]: RouteConfig } = {
  inventory: baseRoute,
  inventoryDetails: {
    path: `${BASE_PATH}/:tab/:view?/:id?`,
    component: Inventory,
    allowedRoles: InternalUserRoles,
  },
};
